// extracted by mini-css-extract-plugin
module.exports = {"col-md-4":"Faqs_col-md-4__qTkWg","aBlockTitle":"Faqs_aBlockTitle__Smlwx","oFaqSectionBlock":"Faqs_oFaqSectionBlock__AFqJ5"};